import { WithTip } from 'components/tooltip/with-tip'
import { CalcStatus } from "data/interface/calc"
import keyService, * as chord from "data/key"
import { local } from 'data/lib/local-json'
import propertyService from 'data/property'
import socketService, * as eventType from "data/socket"
import underwritingService from 'data/underwriting'
import toggles from 'feature-toggles'
import { QuickReportIcon } from 'images/icons/header'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import Isvg from 'react-inlinesvg'
import { ShortcutHint_s } from 'styles/shortcut-styles'

function useForceUpdate(){
  const [_value, setValue] = useState(0);
  return () => setValue(value => value + 1);
}

const PropertyUnderwriting = (props: {position?: string, id?: string, onClick?: Function}) => {
  const [hintsVisible, setHintsVisible] = useState<boolean>(false)
  const forceUpdate = useForceUpdate()
  const type = local('property_type', null)
  const isMultifamily = type == 'Multifamily'
  const isHospitality = type == 'Hospitality'
  let   isCalculated = _.includes([CalcStatus.CALC_WITH_ERR, CalcStatus.CALCULATED], _.get(propertyService.get(), 'calcdetail.status'))
  let   disabled = !isCalculated || !toggles.allowMultifamilyUW() && isMultifamily || isHospitality

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_ALT && k.down === true:
          setHintsVisible(true)
          break
        case k.chord === chord.CTRL_ALT && k.down === false:
          setHintsVisible(false)
          break
        case k.chord === chord.CTRL_ALT_U && k.down === true:
          isCalculated = _.includes([CalcStatus.CALC_WITH_ERR, CalcStatus.CALCULATED], _.get(propertyService.get(), 'calcdetail.status'))
          disabled = !isCalculated || !toggles.allowMultifamilyUW() && isMultifamily || isHospitality
          !disabled && underwritingService.quickReport()
          break
      }
    })

    const socketSubscription = socketService.stream().subscribe(data => {
      switch(true) {
        case data.eventType === eventType.CALC_STATUS:
        case data.eventType === eventType.PROPCHANNEL_CALC_PROPERTY_SYNC:
        case data.eventType === eventType.PROPERTY_SELECTED:
          forceUpdate()
      }
    })

    const propertySubscription = propertyService.stream().subscribe(data => {
      if (data.state !== 'ok') return
      forceUpdate()
    });

    return function cleanup() {
      keySubscription.unsubscribe()
      propertySubscription.unsubscribe()
      socketSubscription.unsubscribe()
    }
  }, [])

  const title =
    !isCalculated ? 'Calculation Required'
    : !toggles.allowMultifamilyUW() && isMultifamily ? 'Not currently supported for multifamily properties'
    : isHospitality ? 'Not currently supported for hospitality properties'
    : 'Property Underwriting Workbook'
    
  return (
    <WithTip position="bottom">
      <span>{title}</span>
      <a className={disabled ? 'disabled' : ''} onClick={(e)=>!disabled && props.onClick ? props.onClick() : underwritingService.quickReport()}>
        <Isvg src={QuickReportIcon} id={props.id || "quickReportIcon"} />
        { hintsVisible && <ShortcutHint_s className="header-hint" visible={hintsVisible}>U</ShortcutHint_s> }
      </a>
    </WithTip>
  )
}

export default PropertyUnderwriting;